import type { EnrichedBlogPage } from '../blog.model';

export function sortByCreatedAtDate(
  a: EnrichedBlogPage,
  b: EnrichedBlogPage
): number {
  return b.createdAtDate.getTime() - a.createdAtDate.getTime();
}
